// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"b7345f04","367":"8fc98da4","396":"fff193f0","865":"7c59c257"}[chunkId] + ".chunk.css";
};